<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <card class="card-pricing bg-gradient-default border-0 text-center mb-4"
                        header-classes="bg-transparent"
                        body-classes="px-lg-7"
                        footer-classes="bg-transparent">

                        <div class="display-3 text-white mb-2">
                            <span>{{ degree.name }}</span>
                        </div>
                        <div class="display-4 text-white mb-2">
                            <small>({{ degree.lang }})</small>
                        </div>
                    </card>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-7">
                    <simulations-crud :degree="degree"></simulations-crud>
                </div>
                <div class="col-lg-5">
                    <resources-crud :degree="degree"></resources-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SimulationsCrud from './degrees/SimulationsCrud'
    import ResourcesCrud from './degrees/ResourcesCrud'

    export default {

        components: {
            SimulationsCrud, ResourcesCrud
        },

        data() {
            return {
                degree: {},
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.degrees'),
                        route: '/astral/ui/training/degrees'
                    },
                    {
                        name: this.degree.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/astral/api/front/degrees/'+to.params.id)
            .then(resp => {
                next(vm => {
                    vm.degree = resp.data.data
                })
            });
        }
    }
</script>
